/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'settings': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M27 21h-1v-9h-3v9h-1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1zm0 3h-5v-.5h5v.5zM35 16h-1v-4h-3v4h-1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1zm0 3h-5v-.5h5v.5zM23 27h3v9h-3zM19 26h-1V12h-3v14h-1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1zm0 3h-5v-.5h5v.5zM31 22h3v14h-3zM15 32h3v4h-3z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/settings.js